export default __webpack_public_path__ + "static/media/higgins.73d7be26.png";